import clientAxios from "./config";
const clientApi = clientAxios;
export default clientApi;
